import _ from "lodash";
import Indicador from "..";
import dcorReport from "./reports";
import dcorReportSummary from "./reports/summary";
import { ACParamFields } from "./components/ACParamFields";
import ACEditFields from "./components/ACEditFields";

export default class AC extends Indicador {
    static get fullName() {
        return "Aferição de Composto";
    }

    static get abbrev() {
        return "AC";
    }

    getAverage(visita, field, tipoName, params) { // pdf da visita ou pdf do laudo
        const apontamentos = visita.getApontamentosByIndicador(this, tipoName)

        if (!_.isEmpty(apontamentos)) {
            if (field === "conformidade") {
                let qtdConforme = 0
                let qtdNaoConforme = 0

                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        if (coleta.conforme === "Sim") {
                            console.log("coleta.conforme ", coleta.conforme);
                            qtdConforme++
                        } else {
                            qtdNaoConforme++
                        }
                    }
                })
                return (qtdConforme * 100) / (qtdConforme + qtdNaoConforme)
            }

            // Coleta 1 - 
            // Coleta 2 - 
            // Coleta 3 - 
            // Coleta 4 - 

            if (field === "conformeColeta1") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeColeta1
                    }
                })

                return conformidade
            }

            if (field === "conformeColeta2") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeColeta2
                    }
                })

                return conformidade
            }

            if (field === "conformeColeta3") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeColeta3
                    }
                })

                return conformidade
            }

            if (field === "conformeColeta4") {
                let conformidade = 0
                apontamentos.forEach(apontamento => {
                    for (const coleta of apontamento.coletas) {
                        conformidade = coleta.conformeColeta4
                    }
                })

                return conformidade
            }
        }
    }

    static paramFields(tipoIndicadorField = '') {
        return <ACParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <ACEditFields visita={visita} TipoClass={TipoClass} />
    }

    async renderReport(visita) {
        return dcorReport(this, visita);
    }

    async renderReportSummary(visita, tipoName) {
        return dcorReportSummary(this, visita, tipoName);
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat
        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0;
        }

        let conformeCount = 0;

        let qtdAcima = 0 // nº de coletas acima da meta
        let sumAcima = 0 // soma das coletas acima da meta

        let qtdAbaixo = 0 // nº de coletas abaixo da meta
        let sumAbaixo = 0 // soma das coletas abaixo da meta

        let mediaConformidade = 0

        const dose = apontamento.dosagemRecomendada ?? 0
        const bandejas = apontamento.qtdBandejas ?? 0

        for (const coleta of apontamento.coletas) {
            const largura = params.largura ?? 0
            const coleta1 = coleta.coleta1 ?? 0
            const coleta2 = coleta.coleta2 ?? 0
            const coleta3 = coleta.coleta3 ?? 0
            const coleta4 = coleta.coleta4 ?? 0
            // const quantColetas = 
            const comprimento = params.comprimento ?? 0
            const areaTalhao = params.areaHa ?? 0
            // const meta = params.meta ?? 0

            const calculoConformidade = dose * (bandejas * (largura * comprimento)) / areaTalhao

            const conformeColeta1 = ((f(coleta1) / calculoConformidade) * 100)
            const conformeColeta2 = ((f(coleta2) / calculoConformidade) * 100)
            const conformeColeta3 = ((f(coleta3) / calculoConformidade) * 100)
            const conformeColeta4 = ((f(coleta4) / calculoConformidade) * 100)

            mediaConformidade = 0

            if (f(coleta1) && f(coleta2) && f(coleta3) && f(coleta4)) {
                mediaConformidade = (f(conformeColeta1) + f(conformeColeta2) + f(conformeColeta3) + f(conformeColeta4)) / 4
            }

            if (f(coleta1) && f(coleta2) && f(coleta3) && !f(coleta4)) {
                mediaConformidade = (f(conformeColeta1) + f(conformeColeta2) + f(conformeColeta3)) / 3
            }

            if (f(coleta1) && f(coleta2) && !f(coleta3) && !f(coleta4)) {
                mediaConformidade = (f(conformeColeta1) + f(conformeColeta2)) / 2
            }

            let min = parseFloat(params.intervaloMin)
            let max = parseFloat(params.intervaloMax)

            if (conformeColeta1 > (max + 15) || conformeColeta1 < (min - 15)) {
                coleta.conformeCol1 = "Não"
            } else {
                coleta.conformeCol1 = "Sim"
            }
            if (conformeColeta2 > (max + 15) || conformeColeta2 < (min - 15)) {
                coleta.conformeCol2 = "Não"
            } else {
                coleta.conformeCol2 = "Sim"
            }
            if (conformeColeta3 > (max + 15) || conformeColeta3 < (min - 15)) {
                coleta.conformeCol3 = "Não"
            } else {
                coleta.conformeCol3 = "Sim"
            }
            if (conformeColeta4 > (max + 15) || conformeColeta4 < (min - 15)) {
                coleta.conformeCol4 = "Não"
            } else {
                coleta.conformeCol4 = "Sim"
            }

            coleta.conformeColeta1 = conformeColeta1
            coleta.conformeColeta2 = conformeColeta2
            coleta.conformeColeta3 = conformeColeta3
            coleta.conformeColeta4 = conformeColeta4
            coleta.mediaConformidade = mediaConformidade
            coleta.acima = mediaConformidade > (max + 15) ? 1 : 0
            coleta.abaixo = mediaConformidade < (min - 15) ? 1 : 0
        }

        apontamento.qtdAcima = qtdAcima

        if (qtdAcima > 0) {
            apontamento.percentAcima = (qtdAcima * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAcima = (sumAcima / qtdAcima)
            apontamento.sumAcima = sumAcima
        } else {
            apontamento.mediaAcima = 0
        }

        apontamento.qtdAbaixo = qtdAbaixo

        if (qtdAbaixo > 0) {
            apontamento.percentAbaixo = (qtdAbaixo * 100) / (conformeCount + qtdAcima + qtdAbaixo)
            apontamento.mediaAbaixo = (sumAbaixo / qtdAbaixo)
            apontamento.sumAbaixo = sumAbaixo
        } else {
            apontamento.mediaAbaixo = 0
        }

        apontamento.qtdConforme = conformeCount

        return mediaConformidade.toFixed(2)
    }

    static getConformidadeStatus(conformidade, meta, apontamento, cliente, type, tipoName) {

        if (!cliente) {
            throw new Error(
                "Este indicador necessita dos dados do cliente para calcular o status de conformidade"
            )
        }

        let cliParam
        if (cliente.getAllParams) {
            cliParam = cliente.getAllParams(this, type)
        } else if (cliente.params) {
            cliParam = _.get(cliente.params, (this.abbrev + type.field).toLowerCase())
        }

        let itensStatus = _.get(cliParam, (tipoName ? tipoName.toLowerCase() + "." : "") + "items")
        let min = parseFloat(cliParam?.mecanizado?.intervaloMin)
        let max = parseFloat(cliParam?.mecanizado?.intervaloMax)

        if (!itensStatus) {
            return this.calcConformidadeStatusDCor(conformidade, min, max);
        }

        return this.calcConformidadeStatusDCor(conformidade, min, max);
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = [];

        for (const item of paramItems) {
            let count = 0;

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.espacamento)) {
                    count++;
                }
            }

            result.push({
                ...item,
                count: count,
            });
        }

        return result;
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        console.log("IndicadorClass ", IndicadorClass);
        console.log("paramsCliente ", paramsCliente);
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Fazenda", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Frota", field: "trator.numeroFrotaTrator", width: 'auto' },
            { title: "Frente", field: "frente", width: 'auto' },
            {
                title: "Operador", width: 'auto', getValue: (a) => {
                    if (a.operador && a.operador.operador) return a.operador.operador
                    if (typeof a.operador === "string" && a.operador) return a.operador
                    return "-"
                }
            },
            { title: "Implemento", field: "implemento.nomeImplemento", width: 'auto' },

            {
                title: "Espaçamento", width: 'auto', getValue: (a) => {
                    let sum = 0
                    let arr = a.coletas.map(x => {
                        if (x.espacamento) {
                            sum = sum + parseFloat(x.espacamento)
                            return x.espacamento
                        } else {
                            return 0
                        }

                    })
                    if (sum) {
                        return (sum / arr.length).toFixed(2)
                    } else {
                        return '0'
                    }
                }
            },

            {
                title: "Conf.(%)", field: "conformidade", width: 38, getColor: a => {
                    return IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta))
                }
            },
        ]
    }

    static getResultStr(apontamento) {
        return "Dosagem Recomendada: " + apontamento.dosagemRecomendada
            + ", Quant. Bandejas: " + apontamento.qtdBandejas
    }
}
